<style>
#measuringPointModal .v--modal-box.v--modal {
  min-width: 380px !important;
  min-height: 320px !important;
}
#measuringPointModal .modal__content {
  overflow-y: hidden !important;
}
.feature-props__container,
#measuringPointModal .v-tabs,
#measuringPointModal .popup__content > li {
  width: 100%;
}
#measuringPointModal .popup__content > li {
  padding-left: 12px;
  padding-right: 12px;
}
#measuringPointModal .container {
  padding: 0 0;
  padding-left: 0;
}
</style>

<template>
  <Modal
    modalName="measuringPointModal" 
    title="Punkt pomiarowy"
    :buttons="['save']"
    @closed="closed"
    @saved="sendProps"
  >

  <v-container>
    <v-layout row wrap>
        <v-tabs
            color="white"
            slider-color="cyan"
        >
        <v-tab key="measurements">Pomiary</v-tab>
        <v-tab key="history">Historia alarmów</v-tab>
        
        <v-tab-item key="measurements">
            <v-card flat>
                <v-subheader>Dane bieżące</v-subheader>
                <div class="feature-props__container" v-html="featureProps"></div>
                <v-subheader>Dane historyczne</v-subheader>
            </v-card>
        </v-tab-item>
        <v-tab-item key="history">
            <v-card flat>
                <div style="height: 150px;">
                <MeasurementHistory />
                </div>
            </v-card>
        </v-tab-item>
        </v-tabs>
    </v-layout>
  </v-container>
    
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import MeasurementHistory from "../../table/MeasurementHistory";

export default {
  components: {
    Modal,
    MeasurementHistory
  },
  props: {
    featureProps: String
  },
  data: () => ({}),
  computed: {},
  methods: {
    closed() {},
    sendProps() {
      this.closed();
      this.$modal.hide("measuringPointModal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/scada/modals/MeasuringPoint.vue